var map = {
	"./AllergenAntipreferencesIcon": [
		33790,
		3790
	],
	"./AllergenAntipreferencesIcon.js": [
		33790,
		3790
	],
	"./ArrowDownIcon": [
		6978,
		6978
	],
	"./ArrowDownIcon.js": [
		6978,
		6978
	],
	"./ArrowPath": [
		95829,
		5829
	],
	"./ArrowPath.js": [
		95829,
		5829
	],
	"./ArrowRightIcon": [
		16879,
		6879
	],
	"./ArrowRightIcon.js": [
		16879,
		6879
	],
	"./ArrowToBottomIcon": [
		51356,
		1356
	],
	"./ArrowToBottomIcon.js": [
		51356,
		1356
	],
	"./ArrowsRotateIcon": [
		24992
	],
	"./ArrowsRotateIcon.js": [
		24992
	],
	"./BinIcon": [
		15610,
		5610
	],
	"./BinIcon.js": [
		15610,
		5610
	],
	"./BoxIcon": [
		83969,
		3969
	],
	"./BoxIcon.js": [
		83969,
		3969
	],
	"./BulletListIcon": [
		66859,
		6859
	],
	"./BulletListIcon.js": [
		66859,
		6859
	],
	"./CalendarIcon": [
		69912,
		9912
	],
	"./CalendarIcon.js": [
		69912,
		9912
	],
	"./CalendarNotOrder": [
		99342,
		9342
	],
	"./CalendarNotOrder.js": [
		99342,
		9342
	],
	"./CashIcon": [
		7549,
		7549
	],
	"./CashIcon.js": [
		7549,
		7549
	],
	"./CheckIcon": [
		46695,
		6695
	],
	"./CheckIcon.js": [
		46695,
		6695
	],
	"./CheckboxCheckedIcon": [
		52379,
		4250
	],
	"./CheckboxCheckedIcon.js": [
		52379,
		4250
	],
	"./CheckboxToCheckIcon": [
		51122,
		1122
	],
	"./CheckboxToCheckIcon.js": [
		51122,
		1122
	],
	"./CheckedCheckbox": [
		61136,
		1136
	],
	"./CheckedCheckbox.js": [
		61136,
		1136
	],
	"./ChevronUpIcon": [
		94159,
		4159
	],
	"./ChevronUpIcon.js": [
		94159,
		4159
	],
	"./CircleInfoIcon": [
		60203,
		1657
	],
	"./CircleInfoIcon.js": [
		60203,
		1657
	],
	"./CirclePauseIcon": [
		2373,
		2373
	],
	"./CirclePauseIcon.js": [
		2373,
		2373
	],
	"./ClientTagAntipreferencesIcon": [
		14694,
		4694
	],
	"./ClientTagAntipreferencesIcon.js": [
		14694,
		4694
	],
	"./ClipboardListIcon": [
		77265,
		7265
	],
	"./ClipboardListIcon.js": [
		77265,
		7265
	],
	"./Clock2Icon": [
		76779,
		6779
	],
	"./Clock2Icon.js": [
		76779,
		6779
	],
	"./ClockIcon": [
		73751,
		3751
	],
	"./ClockIcon.js": [
		73751,
		3751
	],
	"./ContainerIcon": [
		91974,
		1974
	],
	"./ContainerIcon.js": [
		91974,
		1974
	],
	"./CopyIcon": [
		18950,
		8950
	],
	"./CopyIcon.js": [
		18950,
		8950
	],
	"./CopyIconSeccond": [
		65971,
		5971
	],
	"./CopyIconSeccond.js": [
		65971,
		5971
	],
	"./CrownIcon": [
		99454,
		9454
	],
	"./CrownIcon.js": [
		99454,
		9454
	],
	"./DeliveryCarIcon": [
		84645,
		4645
	],
	"./DeliveryCarIcon.js": [
		84645,
		4645
	],
	"./DollarCoinIcon": [
		18376,
		8376
	],
	"./DollarCoinIcon.js": [
		18376,
		8376
	],
	"./EditIcon": [
		33991,
		3991
	],
	"./EditIcon.js": [
		33991,
		3991
	],
	"./EggsIcon": [
		19335,
		9335
	],
	"./EggsIcon.js": [
		19335,
		9335
	],
	"./EllipsisVIcon": [
		33028,
		3028
	],
	"./EllipsisVIcon.js": [
		33028,
		3028
	],
	"./Error404Icon": [
		62574
	],
	"./Error404Icon.js": [
		62574
	],
	"./ExclamationIcon": [
		36000,
		6000
	],
	"./ExclamationIcon.js": [
		36000,
		6000
	],
	"./ExclamationTriangleIcon": [
		93671,
		3671
	],
	"./ExclamationTriangleIcon.js": [
		93671,
		3671
	],
	"./EyeIcon": [
		27504,
		7504
	],
	"./EyeIcon.js": [
		27504,
		7504
	],
	"./FlameIcon": [
		90663,
		663
	],
	"./FlameIcon.tsx": [
		90663,
		663
	],
	"./GoogleIcon": [
		37185,
		7185
	],
	"./GoogleIcon.js": [
		37185,
		7185
	],
	"./HalfStarIcon": [
		23755,
		3755
	],
	"./HalfStarIcon.js": [
		23755,
		3755
	],
	"./HouseIcon": [
		30961
	],
	"./HouseIcon.js": [
		30961
	],
	"./IconAddOutline": [
		52774,
		2774
	],
	"./IconAddOutline.tsx": [
		52774,
		2774
	],
	"./IconArrowBackOutline": [
		87663,
		7663
	],
	"./IconArrowBackOutline.tsx": [
		87663,
		7663
	],
	"./IconArrowForwardOutline": [
		79641,
		9641
	],
	"./IconArrowForwardOutline.tsx": [
		79641,
		9641
	],
	"./IconAssignmentOutline": [
		30778,
		778
	],
	"./IconAssignmentOutline.tsx": [
		30778,
		778
	],
	"./IconAutoRenew": [
		36268,
		6268
	],
	"./IconAutoRenew.tsx": [
		36268,
		6268
	],
	"./IconBlockOutline": [
		60474,
		474
	],
	"./IconBlockOutline.tsx": [
		60474,
		474
	],
	"./IconCalendarTodayOutline": [
		6455,
		6455
	],
	"./IconCalendarTodayOutline.tsx": [
		6455,
		6455
	],
	"./IconCardOutline": [
		31410
	],
	"./IconCardOutline.tsx": [
		31410
	],
	"./IconCheckCircleOutline": [
		59343,
		9343
	],
	"./IconCheckCircleOutline.tsx": [
		59343,
		9343
	],
	"./IconChefHat": [
		11501,
		1501
	],
	"./IconChefHat.tsx": [
		11501,
		1501
	],
	"./IconChevronLeftOutline": [
		19161,
		9161
	],
	"./IconChevronLeftOutline.tsx": [
		19161,
		9161
	],
	"./IconChevronRightOutline": [
		57094,
		7094
	],
	"./IconChevronRightOutline.tsx": [
		57094,
		7094
	],
	"./IconCloseOutline": [
		78737
	],
	"./IconCloseOutline.tsx": [
		78737
	],
	"./IconCreditCardOutline": [
		46140,
		6140
	],
	"./IconCreditCardOutline.tsx": [
		46140,
		6140
	],
	"./IconDeleteOutline": [
		37541,
		7541
	],
	"./IconDeleteOutline.tsx": [
		37541,
		7541
	],
	"./IconDinnerDiningOutline": [
		39233,
		9233
	],
	"./IconDinnerDiningOutline.tsx": [
		39233,
		9233
	],
	"./IconDraftOutline": [
		98301,
		8301
	],
	"./IconDraftOutline.tsx": [
		98301,
		8301
	],
	"./IconEcoOutline": [
		34695,
		449
	],
	"./IconEcoOutline.tsx": [
		34695,
		449
	],
	"./IconEditOutline": [
		12912,
		2912
	],
	"./IconEditOutline.tsx": [
		12912,
		2912
	],
	"./IconErrorOutline": [
		72860,
		2860
	],
	"./IconErrorOutline.tsx": [
		72860,
		2860
	],
	"./IconForkSpoonOutline": [
		61028,
		1028
	],
	"./IconForkSpoonOutline.tsx": [
		61028,
		1028
	],
	"./IconForwardOutline": [
		76006,
		6006
	],
	"./IconForwardOutline.tsx": [
		76006,
		6006
	],
	"./IconGroceryOutline": [
		84446,
		4446
	],
	"./IconGroceryOutline.tsx": [
		84446,
		4446
	],
	"./IconHandMealOutline": [
		65804,
		5804
	],
	"./IconHandMealOutline.tsx": [
		65804,
		5804
	],
	"./IconHistoryOutline": [
		51779
	],
	"./IconHistoryOutline.tsx": [
		51779
	],
	"./IconInfoOutline": [
		95388,
		5388
	],
	"./IconInfoOutline.tsx": [
		95388,
		5388
	],
	"./IconKeyboardArrowDownOutline": [
		38302,
		8302
	],
	"./IconKeyboardArrowDownOutline.tsx": [
		38302,
		8302
	],
	"./IconKeyboardArrowUpOutline": [
		79711,
		9711
	],
	"./IconKeyboardArrowUpOutline.tsx": [
		79711,
		9711
	],
	"./IconListAltOutline": [
		6996,
		6996
	],
	"./IconListAltOutline.tsx": [
		6996,
		6996
	],
	"./IconLocationOnOutline": [
		53209,
		3209
	],
	"./IconLocationOnOutline.tsx": [
		53209,
		3209
	],
	"./IconLogoutOutline": [
		24875
	],
	"./IconLogoutOutline.tsx": [
		24875
	],
	"./IconNoMealsOutline": [
		4409,
		4409
	],
	"./IconNoMealsOutline.tsx": [
		4409,
		4409
	],
	"./IconPercentDiscountOutline": [
		7213
	],
	"./IconPercentDiscountOutline.tsx": [
		7213
	],
	"./IconPersonOutline": [
		42926
	],
	"./IconPersonOutline.tsx": [
		42926
	],
	"./IconPortionBagOutline": [
		49307,
		9307
	],
	"./IconPortionBagOutline.tsx": [
		49307,
		9307
	],
	"./IconQuantityMinus": [
		21740,
		1740
	],
	"./IconQuantityMinus.tsx": [
		21740,
		1740
	],
	"./IconQuantityPlus": [
		5292,
		5292
	],
	"./IconQuantityPlus.tsx": [
		5292,
		5292
	],
	"./IconRemoveOutline": [
		90999,
		999
	],
	"./IconRemoveOutline.tsx": [
		90999,
		999
	],
	"./IconSavingsOutline": [
		13211
	],
	"./IconSavingsOutline.tsx": [
		13211
	],
	"./IconSettingsOutline": [
		29408
	],
	"./IconSettingsOutline.tsx": [
		29408
	],
	"./IconShoppingBagOutline": [
		72334
	],
	"./IconShoppingBagOutline.tsx": [
		72334
	],
	"./IconShoppingCartOutline": [
		50873,
		873
	],
	"./IconShoppingCartOutline.tsx": [
		50873,
		873
	],
	"./IconShoppingModeOutline": [
		15239,
		5239
	],
	"./IconShoppingModeOutline.tsx": [
		15239,
		5239
	],
	"./IconSkilletOutline": [
		5138,
		5138
	],
	"./IconSkilletOutline.tsx": [
		5138,
		5138
	],
	"./IconSpeedOutline": [
		40918
	],
	"./IconSpeedOutline.tsx": [
		40918
	],
	"./IconStarFill": [
		18506,
		8506
	],
	"./IconStarFill.tsx": [
		18506,
		8506
	],
	"./IconStarOutline": [
		99310,
		9310
	],
	"./IconStarOutline.tsx": [
		99310,
		9310
	],
	"./IconStarRating": [
		13087,
		3087
	],
	"./IconStarRating.tsx": [
		13087,
		3087
	],
	"./IconTrendingUpSimple": [
		90136,
		136
	],
	"./IconTrendingUpSimple.tsx": [
		90136,
		136
	],
	"./IconWarningOutline": [
		49009,
		9009
	],
	"./IconWarningOutline.tsx": [
		49009,
		9009
	],
	"./IncognitoIcon": [
		11743
	],
	"./IncognitoIcon.js": [
		11743
	],
	"./InfoIconWithCircle": [
		87055,
		7055
	],
	"./InfoIconWithCircle.js": [
		87055,
		7055
	],
	"./IngredientAntipreferencesIcon": [
		36666,
		6666
	],
	"./IngredientAntipreferencesIcon.js": [
		36666,
		6666
	],
	"./ListIcon": [
		60390,
		390
	],
	"./ListIcon.js": [
		60390,
		390
	],
	"./MapMarkerIcon": [
		17882,
		7882
	],
	"./MapMarkerIcon.js": [
		17882,
		7882
	],
	"./MonitorIcon": [
		10092,
		92
	],
	"./MonitorIcon.js": [
		10092,
		92
	],
	"./NetworkIcon": [
		64294
	],
	"./NetworkIcon.js": [
		64294
	],
	"./NuddleIcon": [
		35115,
		5115
	],
	"./NuddleIcon.js": [
		35115,
		5115
	],
	"./NutIcon": [
		43724,
		3724
	],
	"./NutIcon.js": [
		43724,
		3724
	],
	"./OkIcon": [
		43236,
		3236
	],
	"./OkIcon.js": [
		43236,
		3236
	],
	"./PencilIcon": [
		57668,
		7668
	],
	"./PencilIcon.js": [
		57668,
		7668
	],
	"./PencilLightIcon": [
		69570,
		9570
	],
	"./PencilLightIcon.js": [
		69570,
		9570
	],
	"./PiggyBankIcon": [
		14183,
		4183
	],
	"./PiggyBankIcon.js": [
		14183,
		4183
	],
	"./PlusIcon": [
		9716,
		9716
	],
	"./PlusIcon.js": [
		9716,
		9716
	],
	"./PointerHandIcon": [
		9157,
		9157
	],
	"./PointerHandIcon.js": [
		9157,
		9157
	],
	"./PriceTagIcon": [
		84910,
		4910
	],
	"./PriceTagIcon.js": [
		84910,
		4910
	],
	"./PrinterIcon": [
		18213,
		8213
	],
	"./PrinterIcon.js": [
		18213,
		8213
	],
	"./PuzzleIcon": [
		28135,
		8135
	],
	"./PuzzleIcon.js": [
		28135,
		8135
	],
	"./QuestionCicrle": [
		76391,
		6391
	],
	"./QuestionCicrle.js": [
		76391,
		6391
	],
	"./RedoIcon": [
		96808,
		6808
	],
	"./RedoIcon.js": [
		96808,
		6808
	],
	"./SadShoppingBasketIcon": [
		30265,
		265
	],
	"./SadShoppingBasketIcon.js": [
		30265,
		265
	],
	"./SearchIcon": [
		45857,
		5857
	],
	"./SearchIcon.js": [
		45857,
		5857
	],
	"./SelectAllIcon": [
		38284,
		8284
	],
	"./SelectAllIcon.js": [
		38284,
		8284
	],
	"./ServerIcon": [
		28945
	],
	"./ServerIcon.js": [
		28945
	],
	"./ShareSquareIcon": [
		34907,
		4907
	],
	"./ShareSquareIcon.js": [
		34907,
		4907
	],
	"./ShoppingBagIcon": [
		83604,
		3604
	],
	"./ShoppingBagIcon.js": [
		83604,
		3604
	],
	"./ShoppingBasketIcon": [
		83051,
		7590
	],
	"./ShoppingBasketIcon.js": [
		83051,
		7590
	],
	"./SpinnerIcon": [
		34143,
		4143
	],
	"./SpinnerIcon.js": [
		34143,
		4143
	],
	"./SpinnerThirdIcon": [
		95260,
		5260
	],
	"./SpinnerThirdIcon.js": [
		95260,
		5260
	],
	"./StarIcon": [
		95636,
		5636
	],
	"./StarIcon.js": [
		95636,
		5636
	],
	"./StopIcon": [
		42515,
		2515
	],
	"./StopIcon.js": [
		42515,
		2515
	],
	"./StripeCardIcon": [
		21954,
		1954
	],
	"./StripeCardIcon.js": [
		21954,
		1954
	],
	"./TilesIcon": [
		95997,
		5997
	],
	"./TilesIcon.js": [
		95997,
		5997
	],
	"./TimesIcon": [
		90700,
		700
	],
	"./TimesIcon.js": [
		90700,
		700
	],
	"./TransferIcon": [
		24607,
		4607
	],
	"./TransferIcon.js": [
		24607,
		4607
	],
	"./UncheckedCheckbox": [
		82243,
		2243
	],
	"./UncheckedCheckbox.js": [
		82243,
		2243
	],
	"./UnselectAllIcon": [
		29547,
		9547
	],
	"./UnselectAllIcon.js": [
		29547,
		9547
	],
	"./WarningIcon": [
		9741,
		9741
	],
	"./WarningIcon.js": [
		9741,
		9741
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 69443;
module.exports = webpackAsyncContext;